/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.printing").
controller("dxPrintAnswerItemController", function PrintAnswerItemController(
	$window,

	DX_QUESTION_TYPE,
	DX_EXAM_PARTS,
	examState,
	DX_WORD_GAP_MODE,

	DX_GRADING_TYPES,
	dxBitFlagsHelper,
	dxLocalize
) {
	"use strict";

	var self = this;

	self.DX_WORD_GAP_MODE = DX_WORD_GAP_MODE.STATIC;
	self.DX_GRADING_TYPES = DX_GRADING_TYPES;
	self.DX_EXAM_PARTS = DX_EXAM_PARTS;
	self.DX_QUESTION_TYPE = DX_QUESTION_TYPE;
	self.examState = examState;

	if (self.student) {
		self.displayName = getDisplayName();
	}

	self.origin = $window.location.protocol + "//" + $window.location.host;

	self.capText = [
		dxLocalize.get("WordsNoCap"),
		dxLocalize.get("WordsSoftCap"),
		dxLocalize.get("WordsHardCap"),
	];

	function getDisplayName() {
		var displayName = "";

		if (self.showStudentNames) {
			displayName += self.student.getName(false, false);
		}
		if (self.showStudentCodes) {
			displayName += " (" + self.student.code + ")";
		}
		if (self.showEmail) {
			displayName += " " + self.student.email;
		}
		if (self.exam.anonymous) {
			//Default option for anonymous exams
			displayName = self.student.getName(false, false);
		}
		return displayName;
	}

	self.hasExamPart = function hasExamPart(examPart) {
		return dxBitFlagsHelper.isBitIncluded(self.examParts, examPart);
	};
});
